const DEVELOPMENT = "development";
const STAGING = "staging";
const PRODUCTION = "production";

export default Object.freeze({
  DEVELOPMENT,
  STAGING,
  PRODUCTION,
});
